/**
 * MyShow logomarca — versão PNG oficial.
 * O arquivo está em /public/myshow-logo.png (player 3D roxo + texto MyShow).
 */

interface Props {
  size?: number;
  className?: string;
  showWordmark?: boolean;  // mantido por compat; o PNG já inclui o wordmark
}

const LOGO_SRC = '/myshow-logo.png';

/**
 * Marca apenas (sem texto). Para uso quando o texto MyShow é renderizado separadamente.
 * Renderiza o player 3D recortado do PNG oficial via aspect-ratio.
 */
export function MyShowMark({ size = 32, className = '' }: Pick<Props, 'size' | 'className'>) {
  // O PNG é quadrado e contém mark + texto. Para mostrar só o mark,
  // renderiza o PNG inteiro mas com altura controlada — o texto fica proporcionalmente abaixo.
  // Em contextos onde só queremos o ícone, use height pequena.
  return (
    <img
      src={LOGO_SRC}
      alt="MyShow"
      style={{ height: size * 1.4, width: 'auto' }}
      className={className}
    />
  );
}

/**
 * Logo completa: ícone + texto "MyShow" (cinza/roxo). PNG oficial.
 */
export function MyShowLogoFull({ className = '', height = 40 }: { className?: string; height?: number }) {
  return (
    <img
      src={LOGO_SRC}
      alt="MyShow"
      style={{ height }}
      className={className}
    />
  );
}

/**
 * Versão para fundo escuro — mesmo PNG (o player tem fundo branco interno, mas o
 * arquivo PNG tem fundo transparente fora do player).
 */
export function MyShowLogoNeon({ className = '', height = 40 }: { className?: string; height?: number }) {
  return (
    <img
      src={LOGO_SRC}
      alt="MyShow"
      style={{ height }}
      className={className}
    />
  );
}

/**
 * Versão compacta para headers/sidebars. Usa o PNG inteiro com altura controlada.
 */
export function MyShowLogo({ size = 32, className = '' }: { size?: number; className?: string }) {
  return (
    <img
      src={LOGO_SRC}
      alt="MyShow"
      style={{ height: size * 1.4, width: 'auto' }}
      className={`inline-block ${className}`}
    />
  );
}
